// ** Road List Component
import Table from './Table';

// ** Styles
import '@styles/react/apps/app-roads.scss';
import { useQuery } from '@apollo/client';
import { GET_ROAD_HISTORY } from '../../../../../../graphql/Mutation/roads';

export const RoadsUserQualificationsList = ({ id }) => {
  const variables = {
    id,
    input: {
      page: 1,
      perPage: 10
    }
  };
  const { data, loading, refetch } = useQuery(GET_ROAD_HISTORY, {
    variables,
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'network-only'
  });

  return (
    <div className="road-activities-list">
      <Table
        store={data?.listRoadsHistoryAdminFinished?.docs || []}
        data={{ ...data?.listRoadsHistoryAdminFinished, docs: undefined }}
        loading={loading}
        variables={variables}
        handleFetching={refetch}
      />
    </div>
  );
};
